import * as React from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { useEffect } from 'react';
import TeamDisplayPlayer from './team-display-player';
import { useSiteVarsFunctions } from "../hooks/use-site-vars-functions";


export default function TeamDisplayGrid(teamData) {
  const [team, setTeam] = React.useState({GKP:[], DEF:[], MID:[], FWD:[], Bench:[]});
  const [goalkeepers, setGoalkeepers] = React.useState([]);
  const [defenders, setDefenders] = React.useState([]);
  const [midfielders, setMidfielders] = React.useState([]);
  const [forwards, setForwards] = React.useState([]);
  const [bench, setBench] = React.useState([]);
  const {getPlayerPositionById } = useSiteVarsFunctions();
  
  useEffect(() => {
    const teamPlayers = {GKP:[], DEF:[], MID:[], FWD:[], Bench:[]};
    if(teamData.teamData.players === undefined) {
      return console.log("No players ");
    }
    teamData.teamData.players.forEach((player) => {
      if(player.transfer === "out") {
        teamPlayers.Bench.push(player);
      } else {
        teamPlayers[getPlayerPositionById(player.positionId).name_short].push(player);
      }
    });
    setTeam(teamPlayers);
    setGoalkeepers(teamPlayers.GKP);
    setDefenders(teamPlayers.DEF);
    setMidfielders(teamPlayers.MID);
    setForwards(teamPlayers.FWD);
    setBench(teamPlayers.Bench);
  }, [teamData.teamData.players]);

  return (
    <Box sx={{ flexGrow: 1, paddingBottom: "10px", paddingTop: "10px", background: "url('https://fantasy.premierleague.com/assets/pitch-graphic-t77-OTdp.svg') center top / 625px 420px no-repeat" }}>
      <Grid key="goalkeepers-grid" container spacing={2} minHeight={80} sx={{justifyContent: "center"}}>
        {goalkeepers.map((player) => (
          <TeamDisplayPlayer key={player.playerId} player={player} />
          ))}
      </Grid>
      <Grid key="defenders-grid" container spacing={2} minHeight={80} sx={{justifyContent: "center"}}>
        {defenders.map((player) => (
          <TeamDisplayPlayer key={player.playerId} player={player} />
          ))}
      </Grid>
      <Grid key="midfielders-grid" container spacing={2} minHeight={120} sx={{justifyContent: "center"}}>
        {midfielders.map((player) => (
          <TeamDisplayPlayer key={player.playerId} player={player} />
          ))}
      </Grid>
      <Grid key="forwards-grid" container spacing={2} minHeight={100} sx={{justifyContent: "center"}}>
        {forwards.map((player) => (
          <TeamDisplayPlayer key={player.playerId} player={player} />
          ))}
      </Grid>
      {bench.length > 0 &&
      <Grid key="bench-grid" container spacing={2} minHeight={100} sx={{backgroundColor:"#ccc", margin:"0px", marginTop:"10px", justifyContent: "center"}} >
        {bench.map((player) => (
          <TeamDisplayPlayer key={player.playerId} player={player} />
          ))}
      </Grid>
      }
    </Box>
  );
}